<template>
  <div class="notification-activity_close">
    <FontIcon class="icon-close_solid" />
  </div>
</template>

<script lang="ts" setup>
import FontIcon from '@/components/inputs/icon/font-icon/FontIcon.vue';
</script>
